// extracted by mini-css-extract-plugin
export default {"supportChat":"N6n49jchqBBKveRg32AB","sendButton":"_MamRi9q9J8XNtIi4zm_"};